export const isApplePayNonSafari = (() => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return !isIOS && !isSafari;
})();

export const isDesktopDevice = () => {
    // Check for desktop devices by examining user agent and screen properties
    const userAgent = navigator.userAgent.toLowerCase();

    // Check if it's a mobile device
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);

    // Check if it's a tablet (iPad specifically)
    const isTablet = /ipad|android(?!.*mobile)/i.test(userAgent);

    // Consider it desktop if it's not mobile, not tablet, and has a large screen
    // Also check for common desktop browsers
    const isDesktopBrowser = /windows|macintosh|linux/i.test(userAgent) && !isMobile;

    return !isMobile && !isTablet && isDesktopBrowser;
};

export const isInCrossOriginIframe = () => {
  try {
    if (window === window.top) {
      return false;
    }

    const parentOrigin = window.parent.location.origin;
    const currentOrigin = window.location.origin;
    return parentOrigin !== currentOrigin;
  } catch (e) {
    // If accessing parent.location throws an error, we're in a cross-origin iframe
    return true;
  }
};
